import { useParams } from "react-router-dom";
import { PublicTopNavigation } from "./PublicTopNavigation";

export function NotifyPublicTopNavigation() {
  const { site } = useParams<{ site: string }>();

  return (
    <PublicTopNavigation defaultLink={`/${site}/public/notify/subscription-groups`}>
      <PublicTopNavigation.Link activeWhenURLIncludes='/notify/subscription-groups' to='/notify/subscription-groups'>
        Subscription Groups
      </PublicTopNavigation.Link>
      <PublicTopNavigation.Link activeWhenURLIncludes='/notify/posts' to='/notify/posts'>
        Posts
      </PublicTopNavigation.Link>
    </PublicTopNavigation>
  );
}
